<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="3" xl="3">
        <Docs
          :docs="infoCards.docs"
          :routesConfigDocsCard="routesConfigNoteCard"
          :openAll="openAll"
          @getData="getData"
          @showAll="showAll"
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="3" xl="3">
        <Notes
          :notas="infoCards.notas"
          :routesConfigNoteCard="routesConfigNoteCard"
          :openAll="openAll"
          @getData="getData"
          @showAll="showAll"
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="3" xl="3">
        <Seguimiento
          :logs="infoCards.logs"
          :openAll="openAll"
          @getData="getData"
          @showAll="showAll"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Docs from "@/components/commondComponents/cards/Docs.vue";
import Notes from "@/components/commondComponents/cards/Notes.vue";
import Seguimiento from "@/components/commondComponents/cards/Seguimiento.vue";

export default {
  components: {
    Docs,
    Notes,
    Seguimiento,
  },
  props: {
    infoCards: Object,
  },
  data() {
    return {
      routesConfigNoteCard: {
        route: `/v1/solicitud/documento/upload/${this.$route.params.idSolicitud}`,
        action: "POST",
      },
      switch_data: 1,
      openAll: false,
    };
  },
  methods: {
    getData() {
      this.$emit("getData");
    },
    showAll(val) {
      this.openAll = val;
    },
  },
};
</script>
|
